export default {
    get loginDatas () {
        return JSON.parse(sessionStorage.getItem('loginDatasT') || "{}");
    },
    set loginDatas (value) {
        sessionStorage.setItem('loginDatasT', JSON.stringify(value));
    },
    get UserToken () {
        return sessionStorage.getItem('tokenT');
    },
    set UserToken (value) {
        sessionStorage.setItem('tokenT', value);
    },
    get schoolList () {
        return JSON.parse(sessionStorage.getItem('schoolList'));
    },
    set schoolList (value) {
        sessionStorage.setItem('schoolList', JSON.stringify(value));
    },
    get school_id () {
        return sessionStorage.getItem('school_id');
    },
    set school_id (value) {
        sessionStorage.setItem('school_id', value);
    },
    get sell_type () {
        return sessionStorage.getItem('sell_type');
    },
    set sell_type (value) {
        sessionStorage.setItem('sell_type', value);
    },
    get post_permission_code () {
        return sessionStorage.getItem('post_permission_code');
    },
    set post_permission_code (value) {
        sessionStorage.setItem('post_permission_code', value);
    },
    screenWidth: 0,//屏幕宽度
    /* 导航菜单是否折叠 */
    isSidebarNavCollapse: false,
    /* 面包屑导航列表 */
    crumbList: []
};



// WEBPACK FOOTER //
// ./src/store/state.js